// add any custompage in this array for blocking loginPersistence feature
export const LOGIN_PERSISTENCE_BLOCK_LIST = ['confirm-card', 'integrated/frames'];

export const MODULE_NAME = 'one-identity-root';

export const CREATE_NON_LOGGED_IN_AUTHENTICATION_TOKEN = 'CreateNonLoggedInAuthenticationToken.v1';

export const AMEX_URL = 'http://www.americanexpress.com';

export const localeMap = {
  en_EU: 'en-xb',
  en_EI: 'en-xa',
  no_NO: 'nb-no',
  ch_HK: 'zh-hk',
  en: 'en-US',
  de: 'de-DE',
  es: 'es-ES',
  fi: 'fi-FI',
  fr: 'fr-FR',
  it: 'it-IT',
  ja: 'ja-JP',
  nb: 'nb-NO',
  nl: 'nl-NL',
  sv: 'sv-SE',
  th: 'th-TH',
  zh: 'zh-HK',
};
